import type { DynamicPropertyGroupDto } from "../../types/DynamicPropertyGroupDto";
import type { DynamicPropertyGroupEntity } from "../../types/DynamicPropertyGroupEntity";

export const DynamicPropertyGroupEntityToDto = ({
    dynamicPropertyToGroups,
    id,
    ...rest
}: Readonly<DynamicPropertyGroupEntity>): DynamicPropertyGroupDto => {
    const newDynamicPropertyToGroup = dynamicPropertyToGroups?.map((item) => {
        return {
            ...item,
            terminalExportType: item.terminalExportType ?? "EXPORT_NOT_EMPTY",
            centralExportType: item.centralExportType ?? "EXPORT_NOT_EMPTY",
            changed: undefined,
            mandatory: !!item.mandatory,
            propertyGroupId: id,
            key: item.keyProp || item.key,
        };
    });

    return {
        id,
        dynamicPropertyToGroups: newDynamicPropertyToGroup,
        ...rest,
    };
};
